// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./mermaid.less");

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}


//////////////////
// WEBPACK FOOTER
// ./src/less/default/mermaid.less
// module id = 48
// module chunks = 0